import React, { memo } from 'react';

import LetterContent from '../containers/LetterContent';
import { Data } from '../types';
import Letter from './Letter';

export const MemoizedLetter = memo(({ data }: { data: Data }) => (
  <Letter {...data}>
    <LetterContent data={data} />
  </Letter>
));
